import React, { ReactNode } from 'react';
import { M, colors } from '@dashboard-experience/mastodon';
import { i18n as mastodonI18n } from '@international/mastodon-i18n';
import styled from 'styled-components';

interface PanelTitleInfoProps {
  label: string | ReactNode;
}

const PanelTitleInfoStyled = styled.span`
  margin-left: 6px;
  vertical-align: middle;

  .cds--toggletip {
    position: static;
  }

  .cds--toggletip .cds--popover-caret {
    display: none !important;
  }

  svg {
    width: 16px;
    height: 16px;
    margin: 0 !important;
    fill: ${colors.uiTextPrimaryLight};
  }
`;

const PanelTitleInfo: React.FC<PanelTitleInfoProps> = ({ label }) => {
  const icon = <M.Icon icon='InformationFilled' data-testid='tooltip-icon' />;
  const canHover = globalThis.matchMedia?.('(hover: hover)').matches;

  return (
    <PanelTitleInfoStyled>
      {canHover ? (
        <M.Tooltip align='top' highlighted={false} label={label}>
          {icon}
        </M.Tooltip>
      ) : (
        <M.Toggletip align='bottom'>
          <M.ToggletipButton
            label={mastodonI18n.getStr('components.Report.PanelInfoLabel')}
          >
            {icon}
          </M.ToggletipButton>
          <M.ToggletipContent>
            <p>{label}</p>
          </M.ToggletipContent>
        </M.Toggletip>
      )}
    </PanelTitleInfoStyled>
  );
};

export default PanelTitleInfo;
